var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container o-form-page"},[_c('o-section',{attrs:{"title":_vm.title,"level":0},on:{"click":function($event){return _vm.enableDebug($event)}}},[_c('item-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }